import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';

@Component({
  selector: 'app-bank-name-list',
  templateUrl: './../../../templates/forms/modals/bank-name-list.component.html',
})
export class HrBankNameListComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrBankNameListGrid"

  bankNameList: any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.branchName, field: 'BRANCH_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.bankDtlNo, field: 'BANKDTL_NO', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_SA_COMM_COMPANY_BANKS', JSON.parse(JSON.stringify({ P_COMPANY_NO: globalVariables.userInfo.company_NO }))).subscribe(results => {
      this.bankNameList = results.body; 
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }
}
